function checkMainContentHeight(){
	var windowW = $(window).width();

	if (windowW >= 1092) {
		setTimeout(function(){
			var sidebarH = $('.sidebar').height();
				$('main').animate({
					'min-height': sidebarH
				},200);
		}, 800);
	} else {
		setTimeout(function(){
			$('main').animate({
				'min-height': '1px'
			},200);
		}, 800);
	}
}

$(document).ready(function(){

	var changedPage = false;
	var $dur = 1000;
	var $easing = [0.645, 0.045, 0.355, 1.000];

	// # -- INIT FUNC -- #
	var init = function() {
		console.log('init');
		checkMainContentHeight();
		if ($('body').hasClass('entryId--24')) {
			checkCardElement();
		}
	};

	// # -- AJAX PAGE LOADED -- #
	var ajaxLoad = function(html) {
		init();

		// Update popState event (back/forward browser buttons)
		changedPage = true;
	};

	// # -- AJAX REQUEST -- #
	var loadPage = function(href) {

		// -- Ajax data --
		var data = {};
		data[csrfTokenName] = csrfTokenValue;

		// -- Ajax request --
		$.ajax({
			type: 'POST',
			url: href,
			data: data,
			success: function(result){

				// Variables
				var data = [
					'[data-inject="hero"]',
					'[data-inject="navigation"]',
					'[data-inject="subnav"]',
					'[data-inject="breadcrumb"]',
					'[data-inject="title"]',
					'[data-inject="content"]',
					'[data-inject="sidebarinfos"]',
					'[data-inject="downloads"]',
					'[data-inject="relatedevents"]',
				];

				// Update head title
				var headTitle = $(result).find('[data-inject="title"]').html();
				var $headTitle = $('title');
				$headTitle.html(headTitle + ' - ' + $headTitle.attr('data-siteName'));
				
				// Update content
				for (var i = 0; i < data.length; i++) {
					updateContent(result, data[i]);
				}


			},
			error: function(jqXHR, status, error){
				location.reload();
			}
		});
	};


	// -- Update content --
	var updateContent = function(result, dataElement){
		var newContent = $(result).find(dataElement).html();
		if (newContent !== $(dataElement).html()) {
			$(dataElement).velocity('fadeIn', { duration: $dur }, $easing).html(newContent);
		}
	};

	// -- Init --
	init();

	// -- When the active history entry changes --
	$(window).on('popstate', function(e) {
		if (changedPage) {
			loadPage(location.href);
		}
	});

	// -- Click on subnav --
	$(document).on('click', '[data-inject="subnav"] a', function() {
		var href = $(this).attr('href');
		if (href.indexOf(document.domain) > -1 || href.indexOf(':') === -1) {
			// Push in browser history
			history.pushState({}, '', href);
			// Update content with ajax
			loadPage(href);
			// Update content height p/r sidebar --
			checkMainContentHeight();
			// Check card element --
			if ($(this).hasClass('entryId--24')) {
				setTimeout(function(){
					checkCardElement();
				},1000);
			}
			return false;
		}
	});
	

});


$(window).on('resize orientationchange', function(){
  checkMainContentHeight();
});